import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import icon1 from '../../images/icons/icon_wifi.svg'
import icon2 from '../../images/icons/icon_dollar_2.svg'
import icon3 from '../../images/icons/icon_chart.svg'
import icon4 from '../../images/icons/icon_tag_2.svg'
import icon5 from '../../images/icons/icon_user_2.svg'
import icon6 from '../../images/icons/icon_users.svg'
import icon7 from '../../images/icons/icon_pen.svg'
import icon8 from '../../images/clients/client_logo_9.webp'
import icon9 from '../../images/clients/client_logo_10.webp'
import icon10 from '../../images/avatar/avatar_7.webp'
import nav_image from '../../images/nav_image.png'
import nav_image2 from '../../images/nav_image2.png'
import logo from '../../images/site_logo/Brand.png'
import arrow_right from '../../images/arrow-right.png'
import MobileMenu from '../MobileMenu/MobileMenu'
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';

const Header3 = (props) => {

    const [mobailActive, setMobailState] = useState(false);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const [isSticky, setSticky] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 80) {
                setSticky(false);
            } else {
                setSticky(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Clean up
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);


    return (

        <header className="site_header site_header_3">
            <div className={`header_bottom stricky  ${isSticky ? 'stricked-menu stricky-fixed' : ''}`}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-xl-2 col-lg-2 col-5">
                            
                        </div>
                        <div className="col-xl-8 col-lg-8 col-2">
                            <nav className="main_menu navbar navbar-expand-lg">
                                <div className="main_menu_inner collapse navbar-collapse justify-content-lg-center" id="main_menu_dropdown">
                                    <ul className="main_menu_list menu_css unordered_list justify-content-center">
                                        <li style={{marginRight: '10%'}}>
                                            <Link onClick={ClickHandler} className="site_link" to="/">
                                                <img src={logo} alt="Site Logo – Techco – IT Solutions & Technology, Business Consulting, Software Company Site Template" />
                                            </Link>
                                        </li>
                                        <li className="dropdown">
                                            <Link onClick={ClickHandler} className="nav-link" to="/" id="work_submenu" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                Work
                                            </Link>
                                            <div className="dropdown-menu mega_menu_wrapper" aria-labelledby="work_submenu">
                                                <div className="container">
                                                    <div className="row">
                                                        <div className="col-lg-12">
                                                            <div className="megamenu_pages_wrapper">
                                                                <h3 className="megamenu_info_title mb-0">Work</h3>
                                                            </div>
                                                            <ul className="unordered_list work_ul">
                                                                <li>
                                                                    <p className='work_ul_text'><Link to="/testimonials">Testimonials</Link></p>
                                                                    <div className='nav_text'>
                                                                      <img src={nav_image}/>
                                                                      <p>Digi Pexel helped us build a content-first growth engine that actually converts. Our demos are up, CAC is down.</p>
                                                                    </div>
                                                                </li>
                                                                <li>
                                                                    <p className='work_ul_text'><Link to="/casestudy">Case Studies</Link></p>
                                                                    <div className='nav_text'>
                                                                      <img src={nav_image2}/>
                                                                      <p>Reviving SEO & Building AI <br/> Visibility for a Plate Heat <br/>  Exchanger Manufacturer</p>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="dropdown">
                                            <Link onClick={ClickHandler} className="nav-link" to="/" id="services_submenu" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                Services
                                            </Link>
                                            <div className="dropdown-menu mega_menu_wrapper services_submenu" aria-labelledby="services_submenu">
                                                <div className="container">
                                                    <div className="row justify-content-lg-between">
                                                        <div className="col-lg-12">
                                                            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                                                                    <Row>
                                                                        <Col sm={4}>
                                                                        <div className="megamenu_pages_wrapper">
                                                                            <h3 className="megamenu_info_title mb-0">Services</h3>
                                                                        </div>
                                                                        <Nav variant="pills" className="flex-column services_nav" >
                                                                            <Nav.Item>
                                                                            <Nav.Link eventKey="first">Industries</Nav.Link>
                                                                            </Nav.Item>
                                                                            <Nav.Item>
                                                                            <Nav.Link eventKey="second">Custom AI Solution</Nav.Link>
                                                                            </Nav.Item>
                                                                            <Nav.Item>
                                                                            <Nav.Link eventKey="thired">AI Automation Solution</Nav.Link>
                                                                            </Nav.Item>
                                                                        </Nav>
                                                                        </Col>
                                                                        <Col sm={8}>
                                                                        <Tab.Content>
                                                                            <Tab.Pane eventKey="first">
                                                                                <p className='arrw_css'>Industries&nbsp; <img src={arrow_right}/></p>
                                                                                <div className='row'>
                                                                                    <div className='col-lg-6 col-md-6'>
                                                                                        <div className='services_icon'>
                                                                                            <h3>AI SEO Agency</h3>
                                                                                            <p>Sample def what it is</p>
                                                                                            <Link to="/custom-ai-seo-solution">Learn More&nbsp; <img src={arrow_right}/></Link>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className='col-lg-6 col-md-6'>
                                                                                        <div className='services_icon'>
                                                                                            <h3>B2B SEO Agency</h3>
                                                                                            <p>Sample def what it is</p>
                                                                                            <Link to="/b2b-ai-seo">Learn More&nbsp; <img src={arrow_right}/></Link>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className='col-lg-6 col-md-6'>
                                                                                        <div className='services_icon'>
                                                                                            <h3>SaaS SEO Agency</h3>
                                                                                            <p>Sample def what it is</p>
                                                                                            <Link to="/sasaiseo">Learn More&nbsp; <img src={arrow_right}/></Link>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </Tab.Pane>
                                                                            <Tab.Pane eventKey="second">Second tab content</Tab.Pane>
                                                                            <Tab.Pane eventKey="thired">thired tab content</Tab.Pane>
                                                                        </Tab.Content>
                                                                        </Col>
                                                                    </Row>
                                                                    </Tab.Container>
                                                        </div>
                                                        <div className="social_area">
                                                                <ul className="social_icons_block unordered_list" data-text="">
                                                                    <li>
                                                                        <Link className='progress_css' onClick={ClickHandler} to="/">
                                                                            150+ <span>SEO Clients</span>
                                                                        </Link>
                                                                    </li>
                                                                    <li>
                                                                        <Link className='progress_css' onClick={ClickHandler} to="/">
                                                                            22+ <span>Industries Served</span>
                                                                        </Link>
                                                                    </li>
                                                                    <li>
                                                                        <Link className='progress_css' onClick={ClickHandler} to="/">
                                                                            117+ <span>AI Automation Templates</span>
                                                                        </Link>
                                                                    </li>
                                                                    <li>
                                                                        <Link onClick={ClickHandler} className="creative_btn_new" to="/">
                                                                            <span className="btn_label bg-primary">Book Strategy Call</span>
                                                                        </Link>
                                                                    </li>
                                                                </ul>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="dropdown">
                                            <Link onClick={ClickHandler} className="nav-link" to="/" id="pages_submenu" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                Insights
                                            </Link>
                                            <ul className="dropdown-menu" aria-labelledby="pages_submenu">
                                                
                                                <li><Link onClick={ClickHandler} to="/bloglist">Blogs</Link></li>
                                                <li><Link onClick={ClickHandler} to="/guides">Guides</Link></li>
                                                <li><Link onClick={ClickHandler} to="/contact">Contact Us</Link></li>
                                            </ul>
                                        </li>
                                        <li style={{marginLeft: '10%'}}>
                                            <Link onClick={ClickHandler} className="creative_btn" to="/pricing">
                                                <span className="btn_label bg-primary">Book Strategy Call</span>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </nav>
                        </div>
                        <div className="col-xl-2 col-lg-2 col-5">
                            <ul className="header_btns_group unordered_list justify-content-end">
                                <li>
                                    <button className="mobile_menu_btn" onClick={() => setMobailState(!mobailActive)} type="button" data-bs-toggle="collapse" data-bs-target="#main_menu_dropdown" aria-expanded="false" aria-label="Toggle navigation">
                                        <i className="far fa-bars"></i>
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="mobail-wrap">
                    <div className={`mobail-menu ${mobailActive ? "active" : ""}`}>
                        <div className="xb-header-menu-scroll">
                            <div className="xb-menu-close xb-hide-xl xb-close" onClick={() => setMobailState(!mobailActive)}></div>
                            <nav className="xb-header-nav">
                                <MobileMenu />
                            </nav>
                        </div>
                    </div>
                    <div className="xb-header-menu-backdrop" onClick={() => setMobailState(false)}></div>
                </div>
            </div>
        </header>

    )
}

export default Header3;